import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { ForgotPasswordForm } from 'components/ForgotPasswordForm'

const ForgotPassword = () => {
    return (
        <>
            <Container className="login-page">
                <Row>
                    <Col
                        xs={12}
                        className="container-form d-flex align-items-center justify-content-center"
                    >
                        <ForgotPasswordForm />
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default ForgotPassword
